import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { HolidayPayObligationEntry } from '@/types';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
    import { formatCurrency } from '@/utils/helpers';
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BasicSalaryCalculationHoverCard',
  props: {
    value: {},
    holidayPayObligationEntry: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const caculation = computed(() => {
        return [
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.salary'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.salary,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.fixed_add_ons'),
                amount: formatCurrency(
                    Number(props.holidayPayObligationEntry.calculator.basic_salary.fixed_add_ons),
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.company_pension'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.company_pension,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.free_car_monthly'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.free_car_monthly,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.free_phone_monthly'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.free_phone_monthly,
                ),
            },
            {
                trans: t(
                    'holiday-pay-obligations.entries.tooltip.basic_salary.health_insurance_monthly',
                ),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary
                        .health_insurance_monthly,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.company_atp'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.company_atp,
                ),
            },
        ];
    });

return (_ctx: any,_cache: any) => {
  return (!_ctx.holidayPayObligationEntry.calculator)
    ? (_openBlock(), _createBlock(DataTableCurrency, {
        key: 0,
        value: _ctx.value,
        "return-zero": true
      }, null, 8, ["value"]))
    : (_openBlock(), _createBlock(_unref(HoverCardRoot), {
        key: 1,
        "close-delay": 0,
        "open-delay": 200
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(HoverCardTrigger), null, {
            default: _withCtx(() => [
              _createVNode(DataTableCurrency, {
                value: _ctx.value,
                "return-zero": true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(HoverCardPortal), null, {
            default: _withCtx(() => [
              _createVNode(_unref(HoverCardContent), {
                class: "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 flex flex-col gap-1 rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all",
                "side-offset": 5
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caculation.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: item.trans,
                      class: "text-xs"
                    }, _toDisplayString(index !== 0 ? '+' : '') + _toDisplayString(item.amount) + " (" + _toDisplayString(item.trans) + ") ", 1))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})